@if (isVisibleOnLoading$ | async) {
  <mat-progress-bar mode="indeterminate"></mat-progress-bar>
}

@if (showRotateError) {
  <div class="rotate-warning" *ngIf="showRotateError">
    <p>{{ 'PLEASE_ROTATE_PHONE' | translate }} 📱</p>
  </div>
}
<router-outlet></router-outlet>
